import { vGrubsIncomeEntity } from './api/wallet.types';
import { SimpleUserEntity } from './user.types';

export enum TransactionType {
  vGrubsIncomes = 'vGrubsIncomes',
  vGrubsWithdrawals = 'vGrubsWithdrawals',
  vDriveDeposits = 'vDriveDeposits',
  vDriveTransactions = 'vDriveTransactions',
}

export enum WalletReportType {
  vGrubs = 'vGrubs',
  vDrive = 'vDrive',
}

export type CustomerEntity = {
  customerId: string;
  user: SimpleUserEntity;
};

export type AddBankV2Dto = {
  firstName: string;
  lastName: string;
  email: string;
  businessName?: string | null;
  routingNumber: string;
  accountNumber: string;
  phoneNumber: string;
  zipCode: string;
  address: string;
  streetNumber: string;
  city: string;
  state: string;
  taxClassification: TaxClassification;
  ein?: string | null;
  ssn?: string | null;
};

export type AddBankV2DtoPartner = {
  locationId: number;
  firstName: string;
  lastName: string;
  email: string;
  businessName?: string | null;
  routingNumber: string;
  accountNumber: string;
  phoneNumber: string;
  zipCode: string;
  address: string;
  streetNumber: string;
  city: string;
  state: string;
  taxClassification: TaxClassification;
  ein?: string | null;
  ssn?: string | null;
};

export enum TaxClassification {
  individual = 'individual',
  soleProprietor = 'soleProprietor',
  singleMemberLlc = 'singleMemberLlc',
  cCorporation = 'cCorporation',
  sCorporation = 'sCorporation',
  partnership = 'partnership',
  trust = 'trust',
  estate = 'estate',
  llcPartnership = 'llcPartnership',
  llcCCorporation = 'llcCCorporation',
  llcSCorporation = 'llcSCorporation',
}

export type TransactionPending = {
  // Null/absent while the earning is still being calculated - the final amount
  // only lands once the provider payment report is processed, which is 3 days
  // after order completion for both Uber Eats and Grubhub. Still never render a
  // fixed wait - use `availableAt` from the API.
  amount?: number | null;
  orderId: number;
  locationName: string;
  availableAt: string;
  incomeEntity: vGrubsIncomeEntity;
};
